interface IAbbreviations {
  [key: string]: string;
}

const abbreviations: IAbbreviations = {
  business: "biz",
  company: "co",
  corporation: "corp",
  developer: "dev",
  developers: "dev",
  enterprise: "ent",
  enterprises: "ent",
  technologies: "tech",
  technology: "tech",
  network: "net",
  organisation: "org",
  orginization: "org",
  limited: "ltd",
};

export default abbreviations;
